import {
  enableProdMode,
  APP_INITIALIZER,
  importProvidersFrom,
} from "@angular/core";

import { environment } from "./environments/environment";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { RouterModule } from "@angular/router";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { provideAnimations } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { RoutingState } from "./app/shared/service/routing-state/routing-state.service";
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from "@angular/material/core";
import { MAT_RADIO_DEFAULT_OPTIONS } from "@angular/material/radio";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { TokenInterceptor } from "./app/core/interceptors/token-interceptor";
import { AppInsightsInterceptor } from "./app/core/interceptors/appInsightsInterceptor";
import { UrlRewriteInterceptor } from "./app/core/interceptors/url-rewrite-interceptor";
import { CookieService } from "ngx-cookie-service";
import { FormControl } from "@angular/forms";
import { RolePermissionService } from "./app/core/authentication/services/role-permission.service";
import { UserService } from "./app/core/authentication/services/user.service";
import { AuthService } from "./app/core/authentication/services/auth.service";
import { CoreMemberAccessGuardService } from "./app/core/guards/coremember-guard.service";
import { AuthGuardService } from "./app/core/guards/auth-guard.service";
import { AdminGuardService } from "./app/core/guards/admin-guard.service";
import { provideAuth, getAuth } from "@angular/fire/auth";
import { provideFirebaseApp, initializeApp } from "@angular/fire/app";
import {
  provideHttpClient,
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { BsModalService } from "ngx-bootstrap/modal";
import { RoutesModule } from "./app/routes.module";
import { ApiErrorInterceptor } from "./app/core/interceptors/api-error-interceptor";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      ServiceWorkerModule.register("/ngsw-worker.js", {
        enabled: environment.production,
        registrationStrategy: "registerImmediately",
      }),
      MatProgressBarModule,
      RoutesModule,
      RouterModule
      // SuggestionsModule, // TODO: Finish redesign and enable
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    AdminGuardService,
    AuthGuardService,
    CoreMemberAccessGuardService,
    AuthService,
    UserService,
    RolePermissionService,
    FormControl,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UrlRewriteInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInsightsInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiErrorInterceptor, multi: true },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: "dynamic",
        appearance: "outline",
      },
    },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: "primary" },
    },
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    {
      provide: APP_INITIALIZER,
      useFactory: (_: RoutingState) => () => {},
      deps: [RoutingState],
      multi: true,
    },
    provideAnimations(),
    provideNativeDateAdapter(),
    BsModalService,
  ],
}).catch((err) => console.error("Application Bootrapping Error: ", err));
